import React from 'react';
import { ISvgIconProps, SvgIcon } from './svg-icon.component';
export const ChevronDownIcon: React.FC<ISvgIconProps> = (props) => {
    return (
        <SvgIcon size={1} {...props} viewBox="0 0 10 6" ratio={10 / 6}>
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M9.76517 0.484835C9.61872 0.338388 9.38128 0.338388 9.23484 0.484835L5 4.71967L0.765166 0.484835C0.618718 0.338388 0.381282 0.338388 0.234835 0.484835C0.0883884 0.631281 0.0883884 0.868718 0.234835 1.01516L4.73484 5.51516C4.88128 5.66161 5.11872 5.66161 5.26516 5.51516L9.76517 1.01516C9.91161 0.868719 9.91161 0.631281 9.76517 0.484835Z"
                  fill={props.color? props.color: "currentColor"}/>

        </SvgIcon>
    );
}
